ALKMaps.Control.CustomPlace = ALKMaps.Class(ALKMaps.Control, {
  initialize: function (options) {
    this.handlerOptions = {
      'single': true,
      'double': false,
      'pixelTolerance': 0,
      'stopSingle': false,
      'stopDouble': false
    };
    ALKMaps.Control.prototype.initialize.apply(this, arguments);
    this.handler = new ALKMaps.Handler.Click(this, { 'click': this.trigger }, this.handlerOptions);
  },
  trigger: function (e) {
    this.addCustomPlace({ 'xy': e.xy, "callback": this.addCustomPlaceCB })
  },
  addCustomPlace: function(param) { },
  addCustomPlaceCB: function(param) { },
  CLASS_NAME: "ALKMaps.Control.CustomPlace"
});


// WEBPACK FOOTER //
// ./app/alkmapsExtension/controlCustomPlace.js